import { useParams } from "react-router-dom";
import { useGetHTMLPageQuery } from "htmlpage/api/html-page.api";

export function useHTMLPage() {
  const { htmlPageId } = useParams<{ htmlPageId: string }>();
  return useGetHTMLPageQuery(htmlPageId!).data;
}
